'use strict';

var React = require('react');

function _interopNamespace(e) {
	if (e && e.__esModule) return e;
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n["default"] = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const SvgQuestionCircleAlt = props => /*#__PURE__*/React__namespace.createElement("svg", _extends({
  overflow: "visible",
  preserveAspectRatio: "none",
  viewBox: "0 0 24 24",
  height: 24,
  width: 24
}, props), _path || (_path = /*#__PURE__*/React__namespace.createElement("path", {
  d: "M13.07 14.93a.34.34 0 0 0-.24-.09h-1.66c-.18-.01-.32.13-.33.31v1.69c-.01.18.13.32.31.33h1.69c.18.01.32-.13.33-.31v-1.69a.31.31 0 0 0-.1-.24zM15.83 10c-.01-.88-.43-1.71-1.14-2.23-.69-.59-1.57-.92-2.48-.93-1.48-.05-2.88.72-3.63 2-.05.07-.07.16-.05.24.01.08.05.16.12.21l1.12.85c.06.04.13.06.2.06.1 0 .2-.04.26-.12.24-.32.52-.61.83-.86.3-.2.65-.29 1-.28.36 0 .71.11 1 .31.27.15.44.43.45.74.01.2-.08.39-.23.51-.24.18-.5.33-.78.45l-.5.21c-.15.08-.29.17-.43.27-.16.1-.29.23-.41.37-.11.15-.19.32-.25.49-.07.22-.11.44-.11.67v.71c-.01.18.13.32.31.33h1.69c.18.01.32-.13.33-.31V13.33c0-.11.05-.22.12-.3.08-.1.17-.18.27-.25l.48-.29c.27-.15.47-.27.62-.37.19-.14.37-.29.54-.46.21-.2.37-.45.47-.72.12-.3.19-.62.2-.94zm-1.24-4.13a6.57 6.57 0 0 1 3.55 3.55 6.54 6.54 0 0 1 0 5.17 6.57 6.57 0 0 1-3.55 3.55 6.54 6.54 0 0 1-5.17 0 6.57 6.57 0 0 1-3.55-3.55 6.54 6.54 0 0 1 0-5.17c.66-1.6 1.94-2.88 3.54-3.55 1.65-.71 3.53-.71 5.18 0zM18.92 8A8.016 8.016 0 0 0 16 5.08 7.798 7.798 0 0 0 12 4c-1.41-.01-2.79.37-4 1.08-1.21.7-2.22 1.71-2.92 2.92A7.798 7.798 0 0 0 4 12c-.01 1.41.36 2.79 1.07 4 .7 1.21 1.71 2.22 2.93 2.92 1.21.71 2.59 1.09 4 1.08 1.41.01 2.79-.36 4-1.07 1.21-.7 2.22-1.71 2.92-2.93A7.798 7.798 0 0 0 20 12c.01-1.41-.37-2.79-1.08-4z",
  fill: "currentColor",
  vectorEffect: "non-scaling-stroke"
})));

exports["default"] = SvgQuestionCircleAlt;
